import { toUtcIsoDateTime } from "../../../utils/datetime";

export const UpdateSupportTicketPayload = ({
  priority,
  status,
  assignedToEmail,
  internalNotes,
  dueDate,
  enableCreatorUpdate
}: {
  priority: string;
  status: string;
  assignedToEmail?: string | null;
  internalNotes?: string | null;
  dueDate?: string;
  enableCreatorUpdate: boolean;
}) => ({
  priority,
  status,
  assigned_to_email: assignedToEmail || null,
  internal_notes: internalNotes || null,
  due_date: dueDate ? toUtcIsoDateTime(dueDate) || null : null,
  enable_creator_update: enableCreatorUpdate
});
